export default {
    classes(week) {
        return axios.get("/api/hpc/classes/" + week);
    },
    bookclass(data) {
        return axios.post("/api/hpc/classes/book", data);
    }
};
